import React, { useEffect, useState } from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { VideoSimulation } from './components/VideoSimulation/VideoSimulation';
import { videoConfigService } from './services/videoConfigService';
import type { VideoConfigMap } from './types/video';
import { Preloader } from './components/Preloader/Preloader';
import { ErrorMessage } from './components/ErrorMessage/ErrorMessage';

function App() {
  const [config, setConfig] = useState<VideoConfigMap | null>(null);
  const [error, setError] = useState<string | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchConfig = async () => {
      try {
        const videoConfig = await videoConfigService.getVideoConfig();
        setConfig(videoConfig);
      } catch (err) {
        setError(err instanceof Error ? err.message : 'Failed to load video configuration');
      } finally {
        setLoading(false);
      }
    };

    fetchConfig();
  }, []);

  if (loading) {
    return <Preloader />;
  }

  if (error) {
    return <ErrorMessage message={error} />;
  }

  if (!config) {
    return <ErrorMessage message="No configuration available" />;
  }

  return (
    <BrowserRouter>
      <div className="min-h-screen flex items-center justify-center">
        <Routes>
          <Route path="/" element={<Navigate to="/products" replace />} />
          <Route path="/products" element={<VideoSimulation config={config.addingProducts} />} />
          <Route path="/favorites" element={<VideoSimulation config={config.editFavorites} />} />
          <Route path="/register" element={<VideoSimulation config={config.usingRegister} />} />
          <Route path="/smart-terminal-pro" element={<VideoSimulation config={config.smartTerminalPro} />} />
          <Route path="/smart-terminal-duo" element={<VideoSimulation config={config.smartTerminalDuo} />} />
          <Route path="/athm-sale" element={<VideoSimulation config={config.athmSale} />} />
          <Route path="/athm-refund" element={<VideoSimulation config={config.athmRefund} />} />
        </Routes>
      </div>
    </BrowserRouter>
  );
}

export default App;
